import { COUNTERPARTY_COPY } from "./counterparty.constants.ts";
import { CounterpartyDialog } from "./CounterpartyDialog.tsx";
import { useCounterpartyController } from "./useCounterpartyController.ts";

/**
 * "Check who this is", beside a name on a row that named them — OND-81.
 *
 * SELF-CONTAINED ON PURPOSE. Each place a counterparty is named — an agent on a
 * work, an agent asking to represent one, the seller of a title offer — drops
 * this in with the ONDO id off its own row and nothing else, so no screen's
 * controller grows a profile branch and no screen imports the dialog. The id
 * is one the row already shows; this never resolves a name.
 */
export function CounterpartyCheck({ ondoId, label }: { ondoId: string; label?: string }) {
  const { view, open, close } = useCounterpartyController();

  return (
    <>
      <button
        type="button"
        className="counterparty__check"
        onClick={() => open(ondoId)}
        aria-label={`${COUNTERPARTY_COPY.check}: ${ondoId}`}
      >
        {label ?? COUNTERPARTY_COPY.check}
      </button>
      <CounterpartyDialog view={view} onClose={close} />
    </>
  );
}
